module.exports = __webpack_public_path__ + "static/img/serverNew1.319cb84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serve/serverNew1.jpg
// module id = Orhk
// module chunks = 0